export function hasActiveNotificationFilters(filters = {}) {
  if (filters.searchQuery?.value) {
    return true;
  }

  if (filters.showOnlyUnread?.value !== false) {
    return true;
  }

  return Object.values(filters).some(
    filter => filter?.type === "checkbox" && filter.value === false
  );
}
